module.exports = __webpack_public_path__ + "art-money-logo-white.31176d6e.png";